module.exports = __webpack_public_path__ + "img/news.2fd2f395.png";